import { Body2 } from '@cian/ui-kit';
import {
  IconMapCar16,
  IconMapWalk16,
  IconMapMetroMsk16,
  IconMapMetroSpb16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroNN16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './Underground.css';

import type { ISpecialPromoSecondaryUndergroundSchema } from '../../../../types/specialPromoSecondaryOffers';

const WALK_TRANSPORT_TYPE = 'walk';

const getUndergroundIcon = (cityType?: string | null) => {
  switch (cityType) {
    case 'Spb':
      return IconMapMetroSpb16;
    case 'Samara':
      return IconMapMetroSam16;
    case 'Ekb':
      return IconMapMetroEkb16;
    case 'Kazan':
      return IconMapMetroKzn16;
    case 'Nizhniy':
      return IconMapMetroNN16;
    case 'Novosib':
      return IconMapMetroNovosib16;
    default:
      return IconMapMetroMsk16;
  }
};

type TProps = {
  underground: ISpecialPromoSecondaryUndergroundSchema;
};

export const Underground: React.FC<TProps> = ({ underground }) => {
  const { lineColor, name, timeDisplay, transportType, cityType } = underground;

  const color = React.useMemo(() => (lineColor ? `#${lineColor}` : undefined), [lineColor]);
  const UndergroundIcon = React.useMemo(() => getUndergroundIcon(cityType), [cityType]);

  return (
    <div className={styles['container']}>
      <div className={styles['underground']}>
        {lineColor && cityType && (
          <div style={{ color }}>
            <UndergroundIcon display="block" color="current_color" />
          </div>
        )}
        <Body2 display="block" ellipsis whiteSpace="nowrap">
          {name}
        </Body2>
      </div>
      {timeDisplay && transportType && (
        <div className={styles['transport-time']}>
          {transportType === WALK_TRANSPORT_TYPE ? (
            <IconMapWalk16 display="block" color="icon-secondary-default" />
          ) : (
            <IconMapCar16 display="block" color="icon-secondary-default" />
          )}
          <Body2 display="inline" color="text-secondary-default" whiteSpace="nowrap">
            {timeDisplay}
          </Body2>
        </div>
      )}
    </div>
  );
};
